module.exports = __webpack_public_path__ + "static/media/info-icon.0469f1de.svg";